import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';

function FacebookCircularProgress(props) {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        }}
        size={50}
        thickness={4.5}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) => (theme.palette.mode === 'light' ? '#1e3232' : '#308fe8'),
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={50}
        thickness={4.5}
        {...props}
      />
    </Box>
  );
}

export default function LoadingIndicator() {
  return (
    // <Box sx={{ width: "100%", height: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <Stack spacing={2} sx={{ flexGrow: 1, height:'60vh', display:'flex' ,alignItems:'center', justifyContent:'center'}}> 
      <FacebookCircularProgress  />
    </Stack>
    // </Box>
    
  );
}